var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        [
          _c("span", { staticClass: "text-h6 mobile-text-f16" }, [
            _vm._v("Choose Snowboard Type"),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("modal-close")
                },
              },
            },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "p-4" },
        [
          _c(
            "div",
            { staticClass: "mobile-block" },
            [
              _c(
                "v-row",
                { staticClass: "border-top border-bottom" },
                [
                  _c("v-col", { attrs: { cols: "6", md: "4" } }, [
                    _c("h5", { staticClass: "mobile-text-f16" }, [
                      _vm._v("Renter Name"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-right",
                      attrs: { cols: "6", md: "8" },
                    },
                    [
                      _c("h5", { staticClass: "mobile-text-f16" }, [
                        _vm._v(_vm._s(_vm.customer_name)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "border-bottom",
                      attrs: { cols: "12", md: "4" },
                    },
                    [
                      _c("h5", { staticClass: "mobile-text-f16" }, [
                        _vm._v("Snowboard Type"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-right",
                      attrs: { cols: "12", md: "8" },
                    },
                    [
                      _c(
                        "v-radio-group",
                        {
                          staticClass: "mt-0",
                          attrs: { row: "" },
                          model: {
                            value: _vm.snowboard_type,
                            callback: function ($$v) {
                              _vm.snowboard_type = $$v
                            },
                            expression: "snowboard_type",
                          },
                        },
                        _vm._l(_vm.resources.snowboard_types, function (type) {
                          return _c("v-radio", {
                            key: "radio__snowboard_type_" + type.value,
                            staticClass: "justify-content-end mobile-text-f16",
                            attrs: {
                              value: type.value,
                              label: type.name,
                              column: false,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "desktop-block" },
            [
              _c(
                "v-row",
                { staticClass: "border-top border-bottom" },
                [
                  _c("v-col", { attrs: { cols: "6", md: "4" } }, [
                    _c("h5", { staticClass: "mobile-text-f16" }, [
                      _vm._v("Renter Name"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-right",
                      attrs: { cols: "6", md: "8" },
                    },
                    [
                      _c("h5", { staticClass: "mobile-text-f16" }, [
                        _vm._v("Snowboard Type"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "6", md: "4" } }, [
                    _c("h5", { staticClass: "mobile-text-f16" }, [
                      _vm._v(_vm._s(_vm.customer_name)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-right",
                      attrs: { cols: "6", md: "8" },
                    },
                    [
                      _c(
                        "v-radio-group",
                        {
                          staticClass: "mt-0",
                          attrs: { row: "" },
                          model: {
                            value: _vm.snowboard_type,
                            callback: function ($$v) {
                              _vm.snowboard_type = $$v
                            },
                            expression: "snowboard_type",
                          },
                        },
                        _vm._l(_vm.resources.snowboard_types, function (type) {
                          return _c("v-radio", {
                            key: "radio__snowboard_type_" + type.value,
                            staticClass: "justify-content-end mobile-text-f16",
                            attrs: {
                              value: type.value,
                              label: type.name,
                              column: false,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-row",
            { staticClass: "justify-content-end" },
            [
              _c("v-btn", { attrs: { text: "" }, on: { click: _vm.skip } }, [
                _vm._v("Skip"),
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", text: "" },
                  on: { click: _vm.saveSnowboardType },
                },
                [_vm._v("Continue")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }